<button *ngIf="handle" type="button" class="hs-grip" [class.dragging]="isDragging" [style.left.px]="handle.left"
  [style.top.px]="handle.top" title="Drag to move the HubSpot chat" aria-label="Move the HubSpot chat"
  (pointerdown)="onPointerDown($event)">
  <mat-icon>drag_indicator</mat-icon>
</button>
